import { render, staticRenderFns } from "./comparePatients.vue?vue&type=template&id=670db764&scoped=true&"
import script from "./comparePatients.vue?vue&type=script&lang=js&"
export * from "./comparePatients.vue?vue&type=script&lang=js&"
import style0 from "./comparePatients.vue?vue&type=style&index=0&id=670db764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670db764",
  null
  
)

export default component.exports